// ============================================================
// Clínica — transporte stub (Fase 2)
// ------------------------------------------------------------
// Camada única que simula um backend REST enquanto a API real da
// Clínica não existe (o safetycare-api ainda não tem esse módulo —
// ver README seção "Coordenação Frontend ↔ Backend").
//
// TODO(Fase backend): trocar `resolve(...)` por chamadas AXIOS.
// Este é o ÚNICO arquivo que muda ao ligar na API real: cada método de
// service passa a `return AXIOS.get(...)` em vez de `client.get(fn)`.
// A assinatura (Promise que resolve `{ data }`) é mantida de propósito
// para espelhar o axios e minimizar a migração.
// ============================================================

// Latência simulada (ms). 0 em ambiente de teste para não atrasar o Jest.
const LATENCY =
  typeof process !== "undefined" && process.env.NODE_ENV === "test" ? 0 : 260;

// Injeção de erro para exercitar estados de erro no protótipo:
// use `?fail=1` na URL (lido pelas views) ou chame com { fail: true }.
export class ClinicApiError extends Error {
  constructor(message = "Falha ao comunicar com o servidor", status = 500) {
    super(message);
    this.name = "ClinicApiError";
    this.status = status;
  }
}

function delay(ms) {
  // ms <= 0 (ambiente de teste): resolve como microtask para o flushPromises
  // do Jest funcionar sem fake timers. Em runtime usa setTimeout real.
  return ms > 0
    ? new Promise(resolve => setTimeout(resolve, ms))
    : Promise.resolve();
}

/**
 * Executa um resolver e devolve `{ data }` como o axios.
 * @param {() => any} resolver função que produz o payload (lê/escreve o db em memória)
 * @param {{ fail?: boolean, latency?: number }} [opts]
 * @returns {Promise<{ data: any }>}
 */
async function request(resolver, opts = {}) {
  await delay(opts.latency != null ? opts.latency : LATENCY);
  if (opts.fail) {
    throw new ClinicApiError();
  }
  const data = resolver();
  // Clona para simular serialização de rede (evita mutação acidental do db
  // por referência a partir dos componentes).
  return { data: data === undefined ? null : JSON.parse(JSON.stringify(data)) };
}

export const client = {
  /** GET simulado. */
  get(resolver, opts) {
    return request(resolver, opts);
  },
  /** POST/PUT/PATCH/DELETE simulados (mesma mecânica; nome ajuda a leitura). */
  mutate(resolver, opts) {
    return request(resolver, opts);
  }
};

export default client;
